export const  faceTipBoxZh = {
  notOneself1: '【系统提示】无法识别你的人脸，为避免误判，请保持人脸完整出现在摄像头范围内。',
  multiplayer1: '【系统提示】监测到考场内有其他人在场，为避免误判，请保持考场环境无干扰物。',
  noFace1: '【系统提示】无法识别你的人脸，为避免误判，请保持人脸完整出现在摄像头范围内。',
  notOneself: '[System notice] Face invisible. Please keep look ahead and show your whole face in the camera in case of system misjudgment.',
  multiplayer: "[System notice] Several faces in front of the camera. Please ensure you're ALONE in case of system misjudgment.",
  noFace: '[System notice] Face invisible. Please keep look ahead and show your whole face in the camera in case of system misjudgment.',
  Invigilator: '监考员',
  Administrator: '组委会',
  faceTipBoxSend: '发送',
  proctoringQRcode: 'https://img.webloom.cn/img/proctoringQRcodeZH.png',
  QRCodeHover: 'https://img.webloom.cn/img/QRCodeHoverZH.png',
  QRCodeActive: 'https://img.webloom.cn/img/QRCodeActiveZH.png',
  beginRadio: '监考员广播中，请留意手机。若无法听见，请尝试调高音量或告知监考员。',
  proctorTextRead: '如何重连手机监考二维码？',
  netWorkOffline: '断网',
  netWorkPoor: '较差',
  netWorkUnstable: '中等',
  netWorkGood: '良好',
  netWorkOfflineDesc: `重新连接Wi-Fi或检查路由器电源`,
  netWorkPoorDesc: `尝试连接手机热点或重启路由器`,
  netWorkUnstableDesc: '关闭其他应用或尝试切换网络',
  netWorkGoodDesc: '当前网络条件已满足考试要求',
  faceTipUnfold: '展开'
}

export const  faceTipBoxEn = {
  notOneself1: '【系统提示】无法识别你的人脸，为避免误判，请保持人脸完整出现在摄像头范围内。',
  multiplayer1: '【系统提示】监测到考场内有其他人在场，为避免误判，请保持考场环境无干扰物。',
  noFace1: '【系统提示】无法识别你的人脸，为避免误判，请保持人脸完整出现在摄像头范围内。',
  notOneself: '[System notice] Face invisible. Please keep look ahead and show your whole face in the camera in case of system misjudgment.',
  multiplayer: "[System notice] Several faces in front of the camera. Please ensure you're ALONE in case of system misjudgment.",
  noFace: '[System notice] Face invisible. Please keep look ahead and show your whole face in the camera in case of system misjudgment.',
  Invigilator: 'Invigilator',
  Administrator: 'Organizing Committee',
  faceTipBoxSend: 'send',
  proctoringQRcode: 'https://img.webloom.cn/img/proctoringQRcodeEN1.png',
  QRCodeHover: 'https://img.webloom.cn/img/QRCodeHoverEN1.png',
  QRCodeActive: 'https://img.webloom.cn/img/QRCodeActiveEN1.png',
  beginRadio: 'Invigilator broadcasting. Please pay attention to your phone. If you cannot hear, try to turn the volume up, or inform the invigilator.',
  proctorTextRead: 'How to reconnect to the mobile proctoring?',
  netWorkOffline: 'Offline',
  netWorkPoor: 'Poor',
  netWorkUnstable: 'Unstable',
  netWorkGood: 'Good',
  netWorkOfflineDesc: `Reconnect Wi-Fi or check the router's power supply`,
  netWorkPoorDesc: `Try connecting to your phone's hotspot or restarting the router`,
  netWorkUnstableDesc: 'Close other applications or try switching networks',
  netWorkGoodDesc: 'The current network conditions have met the examination requirements',
  faceTipUnfold: 'Unfold'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/proctor/faceTipBox.js